import React, { useState, useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import { Droppable } from "react-beautiful-dnd";
import { Accordion, Card } from "react-bootstrap";
import { isToday, searchWord } from "../../../helpers/common";
import { findEG } from "../utils";
import EGCard from "./Card";
import { Avatar } from "../../widgets";

const Unassigned = () => {
    const [assignToggle, setAssignToggle] = useState({
        assign: false,
        unAssign: false
    });
    const isRequestingEg = useSelector((state) => state.crewKanban.isRequestingEg);
    const assignedEgList = useSelector((state) => state.crewKanban.crews["assigned"] ? state.crewKanban.crews["assigned"].egList : []);
    const unAssignedEgList = useSelector((state) => state.crewKanban.crews["unassigned"] ? state.crewKanban.crews["unassigned"].egList : []);
    const range = useSelector((state) => state.analyze.searchParams.range);
    const crewList = useSelector((state) => state.crewKanban.crewList);
    const newCrewList = useSelector((state) => state.crewKanban.newCrewList);
    const crews = useSelector((state) => state.crewKanban.crews);
    const columns = useSelector((state) => state.crewKanban.columns);
    const selected = columns.filter(e => e.crewId !== null).map(e => e.crewId);
    const crewSearchText = useSelector((state) => state.crewKanban.crewSearchText);
    const crewFilteredList = useSelector((state) => state.crewKanban.crewFilteredList);


    const handleChangeAccordian = (type) => {
        if (type === "unassigned") {
            if (crewSearchText || (crewSearchText && crewFilteredList.length > 0)) {
                if (assignToggle.assign) {
                    setAssignToggle({ assign: true, unAssign: !assignToggle.unAssign });
                    return;
                }
            }
            setAssignToggle({ assign: false, unAssign: !assignToggle.unAssign });
        } else {
            if (crewSearchText || (crewSearchText && crewFilteredList.length > 0)) {
                if (assignToggle.unAssign) {
                    setAssignToggle({ assign: !assignToggle.assign, unAssign: true });
                    return;
                }
            }
            setAssignToggle({ assign: !assignToggle.assign, unAssign: false });
        }
    }

    const filterLength = (egList, filterIds, searchText) => {
        const length = egList.filter((e) => {
            if (!filterIds) return searchWord(e.name, searchText);
            else if (filterIds && searchText.trim().length === 0) filterIds.includes(e.id);
            return filterIds.includes(e.id) && searchWord(e.name, searchText)
        }).length
        return length;
    }

    const crewNumbers = useMemo(() => {
        const dropdownOptions = [];

        const maxDisplay = 6;
        const oldCrewList = crewList.map(e => {
            const id = e.crew_uuid;
            const name = crews.hasOwnProperty(id) ? crews[id].info.crew_name : e.crew_name;
            return ({ crew_uuid: id, crew_name: name });
        });
        const list = [...oldCrewList, ...newCrewList];
        list.forEach((e, i) => {
            if (!(i < (list.length === maxDisplay ? maxDisplay : maxDisplay - 1)))
                dropdownOptions.push(e);
        });
        return dropdownOptions
    }, [crewList, newCrewList])

    useEffect(() => {
        if ((crewFilteredList && crewFilteredList.length !== 0) || crewSearchText.trim().length !== 0) {
            let assLng = filterLength(assignedEgList, crewFilteredList, crewSearchText);
            let unAssLng = filterLength(unAssignedEgList, crewFilteredList, crewSearchText);
            let assignUnAssignState = assignToggle
            if (assLng !== 0 && unAssLng !== 0) {
                // if (assignUnAssignState.unAssign) assignUnAssignState = { ...assignUnAssignState, assign: true, unAssign: false }
                assignUnAssignState = { ...assignUnAssignState, assign: true, unAssign: true }
            } else if (assLng !== 0 && unAssLng === 0) {
                assignUnAssignState = { ...assignUnAssignState, assign: true, unAssign: false }
            } else if (assLng === 0 && unAssLng !== 0) {
                assignUnAssignState = { ...assignUnAssignState, assign: false, unAssign: true }
            }
            setAssignToggle(assignUnAssignState);
        } else {
            setAssignToggle({ assign: false, unAssign: false });
        }
    }, [crewFilteredList, crewSearchText]);

    return <div className="kanban-column-bg">
        <div className="kanban-column">
            <Accordion className="crewMain_accordion_container">
                <Accordion.Toggle onClick={() => handleChangeAccordian("assigned")}>
                    <div className="kanban-column-header">
                        <Card>
                            <Card.Header className="d-flex crewAssigned">
                                <Card.Title as='div' className="crew_assigned_title">
                                    <Avatar
                                        name={`+${crewNumbers.length}`}
                                        autoTitle="false"
                                        color="gray"
                                        fullText={true}
                                        className={`img-avatar avatar-dropdown 
                                        ${(crewNumbers.filter(e => selected.indexOf(e.id) >= 0).length > 0) ? "selected" : ""}`}
                                    />
                                    <div>
                                        Crews
                                        {assignedEgList && assignedEgList.length > 0 && <span className="ml-1 text-count">
                                            {((crewFilteredList || crewSearchText) && ((crewFilteredList && crewFilteredList.length > 0) || crewSearchText)) ? `(${filterLength(assignedEgList, crewFilteredList, crewSearchText)}/${assignedEgList.length})` : `(${assignedEgList.length})`}
                                        </span>}
                                    </div>
                                </Card.Title>

                                <div>
                                    {!assignToggle.assign ? <i className="fa fa-chevron-down" aria-hidden="true"></i> :
                                        <i className="fa fa-chevron-up" aria-hidden="true"></i>}
                                </div>
                            </Card.Header>
                        </Card>
                    </div>
                </Accordion.Toggle>

                <Accordion.Collapse className={`crewAccordion_content ${assignToggle.assign ? "show" : "hide"}`}>
                    <Droppable droppableId="assigned" isDropDisabled={!isToday(range)}>
                        {(provided, snapshot) => (
                            <div
                                ref={provided.innerRef}
                                className={`kanban-column-body kanban-cards  ${snapshot.isDraggingOver ? "dragging-over" : ""} ${filterLength(assignedEgList, crewFilteredList, crewSearchText) === 0 && 'empty_searchs'}`}
                            >
                                {isRequestingEg && <div className="mt-4 w-100 text-center">Loading...</div>}
                                {!isRequestingEg && assignedEgList.map((eg, index) => (
                                    <EGCard
                                        key={eg.id}
                                        index={index}
                                        egId={eg.id}
                                        crewId={eg.crew && eg.crew.crewId && eg.crew.crewId}
                                        onFilter={e => findEG(e, { searchText: crewSearchText, egIds: crewFilteredList })}
                                        isCardRevert={false}
                                    />
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>

                </Accordion.Collapse>

                <Accordion.Toggle onClick={() => handleChangeAccordian("unassigned")}>
                    <div className="kanban-column-header">
                        <Card>
                            <Card.Header className="d-flex">
                                <Card.Title as='div' className="crewUnassigned">
                                    Unassigned
                                    {unAssignedEgList.length > 0 && <span className="ml-1 text-count">
                                        {((crewFilteredList || crewSearchText) && ((crewFilteredList && crewFilteredList.length > 0) || crewSearchText)) ? `(${filterLength(unAssignedEgList, crewFilteredList, crewSearchText)}/${unAssignedEgList.length})` : `(${unAssignedEgList.length})`}
                                    </span>}
                                </Card.Title>

                                <div>
                                    {assignToggle.unAssign ? <i className="fa fa-chevron-up" aria-hidden="true"></i> : <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                    }
                                </div>
                            </Card.Header>
                        </Card>
                    </div>
                </Accordion.Toggle>


                <Accordion.Collapse className={`crewAccordion_content ${assignToggle.unAssign ? "show" : "hide"}`}>
                    <Droppable droppableId="unassigned" isDropDisabled={!isToday(range)}>
                        {(provided, snapshot) => (
                            <div
                                ref={provided.innerRef}
                                className={`kanban-column-body kanban-cards ${snapshot.isDraggingOver ? "dragging-over" : ""}`}
                            >
                                {isRequestingEg && <div className="mt-4 w-100 text-center">Loading...</div>}
                                {!isRequestingEg && unAssignedEgList.map((eg, index) => (
                                    <EGCard
                                        key={eg.id}
                                        index={index}
                                        egId={eg.id}
                                        crewId="unassigned"
                                        onFilter={e => findEG(e, { searchText: crewSearchText, egIds: crewFilteredList })}
                                        isCardRevert={true}
                                    />
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>

                </Accordion.Collapse>

            </Accordion>
        </div>
    </div >;
};

export default Unassigned;
